export const aboutData = {
  title: "Who am I?",
  description1:
    " I'm a Aspiring Full Stack Developer based in India",
  description2:
  "Right now I fished my Full Stack  Web Development cousre from Masai School, Bengaluru. I love to learn and explore new areas. I am highly-proficient in  Full Stack and eager to learn and ready to contribute to the development of an organization and also open to work as a freelancer.",
  image: 2,
  //I'm  Anil Kumar
};
